import gql from "graphql-tag";

const getListOnBusinessForHr = gql`
  query(
    $startDate: DateTime
    $endDate: DateTime
    $employeeIds: [ID!]
    $departmentIds: [ID!]
    $limit: Int
    $page: Int
  ) {
    getListOnBusinessForHr(
      filter: {
        startDate: $startDate
        endDate: $endDate
        employeeIds: $employeeIds
        departmentIds: $departmentIds
      }
      paging: { limit: $limit, page: $page }
    ) {
      id
      startDate
      endDate
      totalLeaveDays
      totalLeaveHours
      employeeId
      employee {
        id
        fullname
      }
      createdAt
      updatedAt
    }
  }
`;

// ham chi de test
const createOnBusiness = gql`
  mutation(
    $startDate: DateTime!
    $endDate: DateTime!
    $employeeId: ID!
    $totalLeaveDays: Float
    $totalLeaveHours: Float
  ) {
    createOnBusiness(
      data: {
        startDate: $startDate
        endDate: $endDate
        totalLeaveDays: $totalLeaveDays
        totalLeaveHours: $totalLeaveHours
        employeeId: $employeeId
      }
    ) {
      id
      startDate
      endDate
      totalLeaveDays
      totalLeaveHours
      employeeId
      employee {
        id
        fullname
      }
      createdAt
      updatedAt
    }
  }
`;

const deleteOnBusiness = gql`
  mutation($id: ID!) {
    deleteOnBusiness(id: $id) {
      id
    }
  }
`;

export default {
  getListOnBusinessForHr,
  createOnBusiness,
  deleteOnBusiness,
};
